import React, {useEffect, useState} from "react";
import arrow_left from '../../images/arrow--left.svg'
import arrow_right from '../../images/arrow--right.svg'
import {getImage} from "../../contentful/data-provider";
import {renderRichText} from "gatsby-source-contentful/rich-text";

export default function TechSection(props) {
    const content = props.content;

    const slugify = str =>
        str
            .toLowerCase()
            .trim()
            .replace(/[^\w\s-]/g, '')
            .replace(/[\s_-]+/g, '-')
            .replace(/^-+|-+$/g, '');


    let slideSize = props.content.elements.length;
    let elementSize = 0;

    const [currentSlideIndex, setCurrentSliderIndex] = useState(0);
    const [marginLeft, setMarginLeft] = useState(0);


    function slideLeft(){
        if(currentSlideIndex >= 1){
            setCurrentSliderIndex(currentSlideIndex-1);
            setMarginLeft(-(currentSlideIndex-1) * elementSize);
        }
    }
    function slideRight(){
        if(currentSlideIndex < slideSize-1){
            setCurrentSliderIndex(currentSlideIndex+1);
            setMarginLeft(-(currentSlideIndex+1) * elementSize);
        }
    }

    function setSlide(index){
        setCurrentSliderIndex(index);
        return setMarginLeft(-index * elementSize);
    }

    useEffect(()=>{
        elementSize = document.getElementsByClassName('slider-col')[0].offsetWidth;

        if(window.addEventListener) {
            window.addEventListener('resize', function () {
                elementSize = document.getElementsByClassName('slider-col')[0].offsetWidth;
            }, true);
        }
    })

    return (
        <section key={'tech'} className="tech-section">
            <div className="container">
                <div className="tech-slider">
                    <div className="row mt-4">
                        <div className="col-6 col-md-12 mb-4">
                            <h2>{content.title}</h2>
                        </div>
                        <div className="col-12 col-md-10 d-none d-md-block">
                            <ul className="tech-steps">
                                { content.elements.map((element, index) => {
                                    return (
                                        <li className={`${index === currentSlideIndex && 'selected'}`} key={index} onClick={()=>setSlide(index)}>
                                            <a href={'#'+slugify(element.sliderTitle)}>{element.sliderTitle}</a>
                                        </li>
                                    );
                                }) }
                            </ul>
                            <div className="clearfix"/>
                        </div>
                        <div className="col-6 col-md-2">
                            <div className="arrows">
                                <button className="arrow arrow-left" onClick={()=>slideLeft()}><img
                                    src={arrow_left}
                                    alt="Arrow left"/></button>
                                <button className="arrow arrow-right" onClick={()=>slideRight()}><img
                                    src={arrow_right}
                                    alt="Arrow right"/></button>
                            </div>
                        </div>
                    </div>

                    <div id="imagemap">
                        { content.elements.map((element, index) => {
                            return (
                                <a className="mapa" title={slugify(element.sliderTitle)}
                                   alt={slugify(element.sliderTitle)} href={'#'+slugify(element.sliderTitle)} onClick={()=>setSlide(index)}
                                   target="_self" data-image={index} key={index}
                                />
                            );
                        }) }

                        <ul className="slider" style={{marginLeft:marginLeft}}>
                            { content.elements.map((element, index) => {
                                return (
                                    <li className={`slider-col ${index === currentSlideIndex && 'selected'}`} key={index}>
                                        <div className="row">
                                            <div className="col-12 col-md-6 image-col">
                                                <img src={getImage(element.image).url}
                                                     useMap="#imagemap" alt={getImage(element.image).title}/>
                                            </div>
                                            <div className="col-12 col-md-6 text-col">
                                                <h3>{element.title}</h3>
                                                {renderRichText(element.body)}

                                                { (element.ctaText && element.ctaUrl) &&
                                                    <a className="more d-block mt-5 text-decoration-none"
                                                       href={element.ctaUrl}
                                                       target="_blank"
                                                    >
                                                        <i className="fas fa-arrow-right"/>
                                                        {element.ctaText}
                                                    </a>
                                                }

                                            </div>
                                        </div>
                                    </li>
                                );
                            }) }
                        </ul>
                    </div>

                    <div className="clearfix"/>
                </div>
            </div>
        </section>
    )
}
